import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as XIcon } from '../assets/icons/x.svg';

/**
 * Modal centrado en escritorio, sheet deslizado desde abajo en movil (el cambio
 * es puro CSS via media query, ver ui.css .sgc-modal).
 */
function Modal({ open, onClose, title, children, className = '' }) {
  const { t } = useTranslation();
  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (e) => { if (e.key === 'Escape') onClose?.(); };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="sgc-modal__overlay" onClick={onClose}>
      <div
        className={`sgc-modal ${className}`}
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="sgc-modal__handle" />
        {(title || onClose) && (
          <div className="sgc-modal__header">
            {title && <h2 className="sgc-modal__title">{title}</h2>}
            {onClose && (
              <button type="button" className="sgc-modal__close" onClick={onClose} aria-label={t('common.close')}>
                <XIcon width={18} height={18} aria-hidden="true" />
              </button>
            )}
          </div>
        )}
        <div className="sgc-modal__body">{children}</div>
      </div>
    </div>
  );
}

export default Modal;
